import React from "react";

const Banking = () => {
  return <div>Banking</div>;
};

export default Banking;
